<mat-toolbar class="bg-tricon-beige">
    Duplicate Applications
    <button class="pl-4" mat-dialog-close>&times;</button>
</mat-toolbar>

<mat-dialog-content>
    <p class="my-4">Our records indicate that you’ve already applied for {{data.Property.AddressLine1}}. Are you sure you want to submit another application for this home?</p>
</mat-dialog-content>

<mat-dialog-actions class="w-full flex justify-center">
    <div class="grid grid-cols-2">
        <button mat-flat-button class="w-20" color="primary" mat-dialog-close="yes">Yes</button>
        <button mat-flat-button class="w-20" color="primary" (click)="continueApplication()" mat-dialog-close="no">No</button>
    </div>
</mat-dialog-actions>
